import { Component, Input } from '@angular/core';
import { BcContestResult } from '../../models/BcContest';

@Component({
    selector: 'app-bc-contest-result',
    template: `
<span class="result-bubble" *ngIf="value"
    [class.text-bg-success]="isIn"
    [class.text-bg-danger]="isOut"
    [class.text-bg-light]="isNa"
    [title]="'bcContest_result' + value | translate">
<i class="fi fi-rs-check" *ngIf="isIn"></i>
<i class="fi fi-rs-cross" *ngIf="isOut"></i>
<i class="fi fi-rs-minus" *ngIf="isNa"></i>
</span>
`,
    styleUrls: ['./bc-contest.scss']
})
export class BcContestResultComponent {
    @Input() value: BcContestResult;

    get isIn() { return this.value == 'In'; }
    get isOut() { return this.value == 'Out'; }
    get isNa() { return this.value == 'NotApplicable'; }
}
